import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeTags } from '@api';
import { put } from 'redux-saga/effects';
import { selectCurrentInitiativeId } from '../selectors';
import { updateInitiativeReferences } from '../_idMap/actions';

export const coreInitiativesTagsGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, tags) =>
				updateInitiativeReferences([
					{
						initiativeId: request.initiativeId,
						tagIds: tags.map((tag) => tag.id)
					}
				])
		]
	},
	name: 'CoreInitiativesTags',
	receive: true,
	request: true,
	requestHandler: getInitiativeTags,
	retainDataOnRequest: true
});

export function* refreshCurrentInitiativeTagsSaga() {
	const initiativeId: number | undefined = yield selectCurrentInitiativeId();

	if (initiativeId) {
		yield put(
			coreInitiativesTagsGetAsyncSlice.asyncActionCreators.requestGetCoreInitiativesTags({
				initiativeId
			})
		);
	}
}
